import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';

@Component({
  selector: 'app-guide-details-tour-buttons',
  imports: [CommonModule],
  standalone: true,
  template: `
    <div
      class="flex flex-row xl:flex-col flex-wrap items-start xl:items-end gap-2 w-full xl:w-auto"
    >
      <div>
        <button
          (click)="onAddOther()"
          type="button"
          class="rounded-md disabled:opacity-25 bg-columbus-blue-600 px-2 py-1.5 xl:px-1 xl:py-0.5 text-sm font-semibold text-white shadow-xs hover:bg-columbus-blue-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-columbus-blue-600"
        >
          <div class="flex flex-row items-center ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            Sonstiges
          </div>
        </button>
      </div>
      <div *ngIf="!activeStorno.value">
        <button
          (click)="onStornoToggle()"
          type="button"
          class="rounded-md disabled:opacity-25 bg-red-600 px-2 py-1.5 xl:px-1 xl:py-0.5 text-sm font-semibold text-white shadow-xs hover:bg-red-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
        >
          <div class="flex flex-row items-center ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            Storno
          </div>
        </button>
      </div>
    </div>
  `,
  styles: ``,
})
export class GuideDetailsTourButtonsComponent {
  @Input({ required: true }) other!: FormArray;
  @Input({ required: true }) activeStorno!: FormControl;

  fb = inject(FormBuilder);

  onStornoToggle() {
    let val = this.activeStorno.value;
    this.activeStorno.setValue(!val);
  }

  onAddOther() {
    const newOther = this.fb.group({
      text: [''],
    });

    this.other.push(newOther);
  }
}
